import React, { useEffect, useState } from 'react';
import { AddressForm } from '../settings/AddressForm';
import { ChevronRightIcon, MapPinIcon, PlusIcon, SearchIcon, FilterIcon, EditIcon, EyeIcon, TrashIcon, CheckIcon, BuildingIcon, UsersIcon, BriefcaseIcon, ChevronLeftIcon, XIcon } from 'lucide-react';
import { getCountryName } from '../utils/countryUtils';
export function AddressesManagement({
  locale
}) {
  const [view, setView] = useState('list');
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [viewingAddress, setViewingAddress] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [addresses, setAddresses] = useState([
  // Org Unit Addresses
  {
    id: 'addr-001',
    line1: '123 Broadway',
    line2: 'Floor 25',
    city: 'New York',
    state: 'NY',
    postcode: '10001',
    country: 'US',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Org Unit',
      name: 'New York Headquarters',
      id: 'org-002'
    }
  }, {
    id: 'addr-002',
    line1: '456 Market Street',
    line2: 'Suite 300',
    city: 'San Francisco',
    state: 'CA',
    postcode: '94105',
    country: 'US',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Org Unit',
      name: 'San Francisco Office',
      id: 'org-003'
    }
  }, {
    id: 'addr-003',
    line1: '10 Downing Street',
    line2: '',
    city: 'London',
    state: '',
    postcode: 'SW1A 2AA',
    country: 'GB',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Global Logistics Partners',
      id: 'vendor-005'
    }
  }, {
    id: 'addr-004',
    line1: '100 George Street',
    line2: '',
    city: 'Sydney',
    state: 'NSW',
    postcode: '2000',
    country: 'AU',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Org Unit',
      name: 'Sydney Office',
      id: 'org-007'
    }
  }, {
    id: 'addr-005',
    line1: '123 Business Park Dr',
    line2: 'Building A',
    city: 'Austin',
    state: 'TX',
    postcode: '78701',
    country: 'US',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Office Depot',
      id: 'vendor-001'
    }
  },
  // Additional Vendor Addresses
  {
    id: 'addr-006',
    line1: '500 Dell Way',
    line2: '',
    city: 'Round Rock',
    state: 'TX',
    postcode: '78682',
    country: 'US',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Dell Technologies',
      id: 'vendor-002'
    }
  }, {
    id: 'addr-007',
    line1: '789 Print Street',
    line2: 'Unit 12',
    city: 'Toronto',
    state: 'ON',
    postcode: 'M5H 2N2',
    country: 'CA',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'PrintWorks Inc.',
      id: 'vendor-003'
    }
  }, {
    id: 'addr-008',
    line1: '321 Construction Blvd',
    line2: '',
    city: 'Los Angeles',
    state: 'CA',
    postcode: '90012',
    country: 'US',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Acme Construction',
      id: 'vendor-004'
    }
  }, {
    id: 'addr-009',
    line1: '1-2-3 Shibuya',
    line2: 'Tokyo Tower',
    city: 'Tokyo',
    state: '',
    postcode: '150-0002',
    country: 'JP',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Pacific Manufacturing',
      id: 'vendor-008'
    }
  }, {
    id: 'addr-010',
    line1: 'Hauptstrasse 123',
    line2: '',
    city: 'Berlin',
    state: '',
    postcode: '10115',
    country: 'DE',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'TechSupply Co.',
      id: 'vendor-006'
    }
  }, {
    id: 'addr-011',
    line1: '555 Green Energy Way',
    line2: 'Suite 100',
    city: 'Portland',
    state: 'OR',
    postcode: '97201',
    country: 'US',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Green Energy Solutions',
      id: 'vendor-007'
    }
  }, {
    id: 'addr-012',
    line1: '88 Marketing Plaza',
    line2: '',
    city: 'Manchester',
    state: '',
    postcode: 'M1 1AD',
    country: 'GB',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Digital Marketing Pro',
      id: 'vendor-014'
    }
  }, {
    id: 'addr-013',
    line1: '200 Finance Street',
    line2: 'Floor 5',
    city: 'New York',
    state: 'NY',
    postcode: '10002',
    country: 'US',
    addressType: 'Billing',
    isPrimary: false,
    association: {
      type: 'Org Unit',
      name: 'Finance Department',
      id: 'org-005'
    }
  }, {
    id: 'addr-014',
    line1: '777 Cleaning Ave',
    line2: '',
    city: 'New York',
    state: 'NY',
    postcode: '10003',
    country: 'US',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Metro Cleaning Services',
      id: 'vendor-009'
    }
  }, {
    id: 'addr-015',
    line1: '999 Consulting Plaza',
    line2: 'Suite 500',
    city: 'San Francisco',
    state: 'CA',
    postcode: '94111',
    country: 'US',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Elite Consulting Group',
      id: 'vendor-010'
    }
  }, {
    id: 'addr-016',
    line1: '444 Supply Road',
    line2: '',
    city: 'Vancouver',
    state: 'BC',
    postcode: 'V6B 4Y8',
    country: 'CA',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Northern Supplies Ltd',
      id: 'vendor-011'
    }
  }, {
    id: 'addr-017',
    line1: '222 Security Blvd',
    line2: '',
    city: 'Los Angeles',
    state: 'CA',
    postcode: '90015',
    country: 'US',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Apex Security Systems',
      id: 'vendor-012'
    }
  }, {
    id: 'addr-018',
    line1: '66 Rue de la Paix',
    line2: '',
    city: 'Paris',
    state: '',
    postcode: '75002',
    country: 'FR',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Continental Foods',
      id: 'vendor-013'
    }
  }, {
    id: 'addr-019',
    line1: '333 Parts Avenue',
    line2: 'Warehouse 5',
    city: 'Los Angeles',
    state: 'CA',
    postcode: '90021',
    country: 'US',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Industrial Parts Warehouse',
      id: 'vendor-015'
    }
  }, {
    id: 'addr-020',
    line1: '888 Transport Way',
    line2: '',
    city: 'New York',
    state: 'NY',
    postcode: '10004',
    country: 'US',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Swift Transportation',
      id: 'vendor-016'
    }
  }, {
    id: 'addr-021',
    line1: 'Via Milano 45',
    line2: '',
    city: 'Milan',
    state: '',
    postcode: '20121',
    country: 'IT',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Premium Office Furniture',
      id: 'vendor-017'
    }
  }, {
    id: 'addr-022',
    line1: '111 Cloud Street',
    line2: 'Floor 12',
    city: 'New York',
    state: 'NY',
    postcode: '10005',
    country: 'US',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'CloudTech Solutions',
      id: 'vendor-018'
    }
  }, {
    id: 'addr-023',
    line1: '555 Maintenance Lane',
    line2: '',
    city: 'Honolulu',
    state: 'HI',
    postcode: '96813',
    country: 'US',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Reliable Maintenance Co.',
      id: 'vendor-019'
    }
  }, {
    id: 'addr-024',
    line1: '99 Trade Center',
    line2: 'Building 8',
    city: 'Beijing',
    state: '',
    postcode: '100000',
    country: 'CN',
    addressType: 'Physical',
    isPrimary: true,
    association: {
      type: 'Vendor',
      name: 'Global Trade Partners',
      id: 'vendor-020'
    }
  }]);
  const filteredAddresses = addresses.filter(address => {
    const matchesSearch = address.line1.toLowerCase().includes(searchTerm.toLowerCase()) || address.city.toLowerCase().includes(searchTerm.toLowerCase()) || address.addressType.toLowerCase().includes(searchTerm.toLowerCase()) || getCountryName(address.country).toLowerCase().includes(searchTerm.toLowerCase());
    const matchesType = filterType === 'All' || address.association && address.association.type === filterType;
    return matchesSearch && matchesType;
  });
  // Pagination calculations
  const totalItems = filteredAddresses.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedAddresses = filteredAddresses.slice(startIndex, endIndex);
  // Reset to page 1 when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filterType]);
  const handlePageChange = page => {
    setCurrentPage(page);
  };
  const handleEdit = (address, e) => {
    if (e) e.stopPropagation();
    setSelectedAddress(address);
    setView('form');
  };
  const handleView = (address, e) => {
    if (e) e.stopPropagation();
    setViewingAddress(address);
  };
  const handleCreate = () => {
    setSelectedAddress(null);
    setView('form');
  };
  const handleDelete = id => {
    if (window.confirm('Are you sure you want to delete this address?')) {
      setAddresses(addresses.filter(addr => addr.id !== id));
    }
  };
  const handleSave = addressData => {
    if (addressData.id) {
      // Update existing address
      setAddresses(addresses.map(addr => {
        if (addr.id === addressData.id) {
          return {
            ...addressData,
            association: addr.association
          };
        }
        // If this one is set to primary, unset others
        if (addressData.isPrimary) {
          return {
            ...addr,
            isPrimary: false
          };
        }
        return addr;
      }));
    } else {
      // Create new address
      const newAddress = {
        ...addressData,
        id: `addr-${Date.now()}`,
        association: null
      };
      let updatedAddresses = [...addresses];
      // If new address is primary, unset others
      if (newAddress.isPrimary) {
        updatedAddresses = updatedAddresses.map(addr => ({
          ...addr,
          isPrimary: false
        }));
      }
      setAddresses([...updatedAddresses, newAddress]);
    }
    setView('list');
  };
  const handleCancel = () => {
    setView('list');
    setSelectedAddress(null);
  };
  const getAssociationIcon = type => {
    switch (type) {
      case 'Vendor':
        return <BriefcaseIcon className="h-3 w-3 mr-1" data-id="element-6618" />;
      case 'Org Unit':
        return <UsersIcon className="h-3 w-3 mr-1" data-id="element-6619" />;
      case 'Contact':
        return <UsersIcon className="h-3 w-3 mr-1" data-id="element-6620" />;
      default:
        return <UsersIcon className="h-3 w-3 mr-1" data-id="element-6621" />;
    }
  };
  const getAssociationColor = type => {
    switch (type) {
      case 'Vendor':
        return 'bg-blue-100 text-blue-800';
      case 'Org Unit':
        return 'bg-orange-100 text-orange-800';
      case 'Contact':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <div className="space-y-6" data-id="element-6622">
      <div className="mb-8" data-id="element-6623">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-6624">Address Management</h2>
        <p className="mt-1 text-sm text-gray-500" data-id="element-6625">
          A centralized view of all addresses across the organization and their
          associations
        </p>
      </div>

      {view === 'list' && <>
          {/* Filters and Search */}
          <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-6626">
            <div className="relative max-w-xs w-full" data-id="element-6627">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-6628">
                <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" data-id="element-6629" />
              </div>
              <input type="text" className="block w-full rounded-md border-gray-300 pl-10 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" placeholder="Search addresses..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-6630" />
            </div>

            <div className="flex items-center gap-2" data-id="element-6631">
              <FilterIcon className="h-5 w-5 text-gray-400" data-id="element-6632" />
              <span className="text-sm text-gray-700" data-id="element-6633">Filter by usage:</span>
              <select className="block rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm" value={filterType} onChange={e => setFilterType(e.target.value)} data-id="element-6634">
                <option value="All" data-id="element-6635">All Associations</option>
                <option value="Vendor" data-id="element-6636">Vendors</option>
                <option value="Org Unit" data-id="element-6637">Org Units</option>
                <option value="Contact" data-id="element-6638">Contacts</option>
              </select>
            </div>
          </div>

          {/* Content */}
          <div className="flex flex-col lg:flex-row gap-8" data-id="element-6639">
            {/* Table */}
            <div className={`flex-1 ${viewingAddress ? 'hidden lg:block lg:w-2/3' : 'w-full'}`} data-id="element-6640">
              <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" data-id="element-6641">
                <table className="min-w-full divide-y divide-gray-300" data-id="element-6642">
                  <thead className="bg-gray-50" data-id="element-6643">
                    <tr data-id="element-6644">
                      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6" data-id="element-6645">
                        Type
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-6646">
                        Address
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-6647">
                        City / Country
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-6648">
                        Used In
                      </th>
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6" data-id="element-6649">
                        <span className="sr-only" data-id="element-6650">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white" data-id="element-6651">
                    {paginatedAddresses.length > 0 ? paginatedAddresses.map(address => <tr key={address.id} className={`hover:bg-gray-50 ${viewingAddress?.id === address.id ? 'bg-indigo-50' : ''}`} data-id="element-6652">
                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6" data-id="element-6653">
                            <div className="flex items-center" data-id="element-6654">
                              <MapPinIcon className="h-5 w-5 text-gray-400 mr-3" data-id="element-6655" />
                              <div data-id="element-6656">
                                <div className="font-medium text-gray-900" data-id="element-6657">
                                  {address.addressType}
                                </div>
                                {address.isPrimary && <span className="inline-flex items-center rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800" data-id="element-6658">
                                    <CheckIcon className="h-3 w-3 mr-1" data-id="element-6659" />
                                    Primary
                                  </span>}
                              </div>
                            </div>
                          </td>
                          <td className="px-3 py-4 text-sm text-gray-500" data-id="element-6660">
                            <div data-id="element-6661">
                              <div data-id="element-6662">{address.line1}</div>
                              {address.line2 && <div className="text-gray-400" data-id="element-6663">
                                  {address.line2}
                                </div>}
                            </div>
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" data-id="element-6664">
                            <div data-id="element-6665">
                              <div data-id="element-6666">
                                {address.city}
                                {address.state && `, ${address.state}`}
                              </div>
                              <div className="text-gray-400" data-id="element-6667">
                                {getCountryName(address.country)}
                              </div>
                            </div>
                          </td>
                          <td className="px-3 py-4 text-sm text-gray-500" data-id="element-6668">
                            <div className="flex flex-wrap gap-1" data-id="element-6669">
                              {address.association ? <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${getAssociationColor(address.association.type)}`} data-id="element-6670">
                                  {getAssociationIcon(address.association.type)}
                                  {address.association.name}
                                </span> : <span className="text-gray-400 italic" data-id="element-6671">
                                  Unused
                                </span>}
                            </div>
                          </td>
                          <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6" data-id="element-6672">
                            <div className="flex justify-end gap-2" data-id="element-6673">
                              <button type="button" onClick={e => handleEdit(address, e)} className="text-indigo-600 hover:text-indigo-900" data-id="element-6674">
                                <EditIcon className="h-4 w-4" data-id="element-6675" />
                                <span className="sr-only" data-id="element-6676">
                                  Edit, {address.addressType}
                                </span>
                              </button>
                              <button type="button" onClick={e => handleView(address, e)} className="text-green-600 hover:text-green-900" data-id="element-6677">
                                <EyeIcon className="h-4 w-4" data-id="element-6678" />
                                <span className="sr-only" data-id="element-6679">
                                  View, {address.addressType}
                                </span>
                              </button>
                              <button type="button" onClick={() => handleDelete(address.id)} className="text-red-600 hover:text-red-900" data-id="element-6680">
                                <TrashIcon className="h-4 w-4" data-id="element-6681" />
                                <span className="sr-only" data-id="element-6682">
                                  Delete, {address.addressType}
                                </span>
                              </button>
                            </div>
                          </td>
                        </tr>) : <tr data-id="element-6683">
                        <td colSpan={5} className="py-8 text-center text-sm text-gray-500" data-id="element-6684">
                          No addresses found matching your criteria.
                        </td>
                      </tr>}
                  </tbody>
                </table>

                {/* Pagination */}
                {totalPages > 1 && <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" data-id="element-6685">
                    <div className="flex-1 flex justify-between sm:hidden" data-id="element-6686">
                      <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-6687">
                        Previous
                      </button>
                      <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-6688">
                        Next
                      </button>
                    </div>
                    <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-6689">
                      <div data-id="element-6690">
                        <p className="text-sm text-gray-700" data-id="element-6691">
                          Showing{' '}
                          <span className="font-medium" data-id="element-6692">{startIndex + 1}</span>{' '}
                          to{' '}
                          <span className="font-medium" data-id="element-6693">
                            {Math.min(endIndex, totalItems)}
                          </span>{' '}
                          of <span className="font-medium" data-id="element-6694">{totalItems}</span>{' '}
                          results
                        </p>
                      </div>
                      <div data-id="element-6695">
                        <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-6696">
                          <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-6697">
                            <span className="sr-only" data-id="element-6698">Previous</span>
                            <ChevronLeftIcon className="h-5 w-5" data-id="element-6699" />
                          </button>
                          {[...Array(totalPages)].map((_, idx) => {
                      const page = idx + 1;
                      if (page === 1 || page === totalPages || page >= currentPage - 1 && page <= currentPage + 1) {
                        return <button key={page} onClick={() => handlePageChange(page)} className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${page === currentPage ? 'z-10 bg-indigo-50 border-indigo-500 text-indigo-600' : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'}`} data-id="element-6700">
                                  {page}
                                </button>;
                      } else if (page === currentPage - 2 || page === currentPage + 2) {
                        return <span key={page} className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700" data-id="element-6701">
                                  ...
                                </span>;
                      }
                      return null;
                    })}
                          <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-6702">
                            <span className="sr-only" data-id="element-6703">Next</span>
                            <ChevronRightIcon className="h-5 w-5" data-id="element-6704" />
                          </button>
                        </nav>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>

            {/* Address Details Panel */}
            {viewingAddress && <div className="w-full lg:w-1/3 bg-white shadow rounded-lg border border-gray-200 p-6 h-fit sticky top-6" data-id="element-6705">
                <div className="flex justify-between items-start mb-6" data-id="element-6706">
                  <div className="flex items-center" data-id="element-6707">
                    <div className="h-12 w-12 rounded-full bg-indigo-100 flex items-center justify-center mr-4" data-id="element-6708">
                      <MapPinIcon className="h-6 w-6 text-indigo-600" data-id="element-6709" />
                    </div>
                    <div data-id="element-6710">
                      <h2 className="text-xl font-bold text-gray-900" data-id="element-6711">
                        {viewingAddress.addressType}
                      </h2>
                      <p className="text-sm text-gray-500" data-id="element-6712">
                        {viewingAddress.city},{' '}
                        {getCountryName(viewingAddress.country)}
                      </p>
                    </div>
                  </div>
                  <button onClick={() => setViewingAddress(null)} className="text-gray-400 hover:text-gray-500" data-id="element-6713">
                    <XIcon className="h-5 w-5" data-id="element-6714" />
                  </button>
                </div>

                <div className="space-y-6" data-id="element-6715">
                  <div data-id="element-6716">
                    <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-3" data-id="element-6717">
                      Address Details
                    </h3>
                    <div className="space-y-2 text-sm" data-id="element-6718">
                      <div className="text-gray-900" data-id="element-6719">
                        {viewingAddress.line1}
                      </div>
                      {viewingAddress.line2 && <div className="text-gray-900" data-id="element-6720">
                          {viewingAddress.line2}
                        </div>}
                      <div className="text-gray-900" data-id="element-6721">
                        {viewingAddress.city}
                        {viewingAddress.state && `, ${viewingAddress.state}`}{' '}
                        {viewingAddress.postcode}
                      </div>
                      <div className="text-gray-900" data-id="element-6722">
                        {getCountryName(viewingAddress.country)}
                      </div>
                      <div className="flex items-center pt-3" data-id="element-6723">
                        <CheckIcon className={`h-5 w-5 mr-3 ${viewingAddress.isPrimary ? 'text-green-500' : 'text-gray-300'}`} data-id="element-6724" />
                        <span className={viewingAddress.isPrimary ? 'text-gray-900 font-medium' : 'text-gray-500'} data-id="element-6725">
                          {viewingAddress.isPrimary ? 'Primary Address' : 'Secondary Address'}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="border-t border-gray-200 pt-6" data-id="element-6726">
                    <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-3" data-id="element-6727">
                      Used In
                    </h3>
                    {viewingAddress.association ? <div className="py-3 flex items-center justify-between" data-id="element-6728">
                        <div className="flex items-center" data-id="element-6729">
                          <span className={`inline-flex items-center justify-center h-8 w-8 rounded-full mr-3 ${getAssociationColor(viewingAddress.association.type)} bg-opacity-20`} data-id="element-6730">
                            {getAssociationIcon(viewingAddress.association.type)}
                          </span>
                          <div data-id="element-6731">
                            <p className="text-sm font-medium text-gray-900" data-id="element-6732">
                              {viewingAddress.association.name}
                            </p>
                            <p className="text-xs text-gray-500" data-id="element-6733">
                              {viewingAddress.association.type}
                            </p>
                          </div>
                        </div>
                        <button className="text-xs text-indigo-600 hover:text-indigo-900 font-medium" data-id="element-6734">
                          View
                        </button>
                      </div> : <p className="text-sm text-gray-500 italic" data-id="element-6735">
                        This address is not currently associated with any
                        record.
                      </p>}
                  </div>

                  <div className="border-t border-gray-200 pt-6 flex justify-end gap-3" data-id="element-6736">
                    <button onClick={e => handleEdit(viewingAddress, e)} className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-6737">
                      <EditIcon className="h-4 w-4 mr-2" data-id="element-6738" />
                      Edit
                    </button>
                    <button onClick={() => handleDelete(viewingAddress.id)} className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" data-id="element-6739">
                      <TrashIcon className="h-4 w-4 mr-2" data-id="element-6740" />
                      Delete
                    </button>
                  </div>
                </div>
              </div>}
          </div>
        </>}

      {view === 'form' && <div className="bg-white shadow sm:rounded-lg" data-id="element-6741">
          <div className="px-4 py-5 sm:p-6" data-id="element-6742">
            <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4" data-id="element-6743">
              {selectedAddress ? 'Edit Address' : 'New Address'}
            </h3>
            <AddressForm address={selectedAddress} onSave={handleSave} onCancel={handleCancel} locale={locale} data-id="element-6744" />
          </div>
        </div>}
    </div>;
}